<template>
  <div class="w100 pt20 pb20 bg-w">
    <div class="w120 mc pt20 pb20">

      <div class="module-box" v-for="(item, index) in moduleData.cardModules" :key="item.code">
        <p class="w100 font-36 tx-c">主题分类</p>
        
        <div class="tab flex-box ju-c mt20" >
          <template v-for="(e, i) in item.data" >
            <div class="tab-item " @click="tabClick(e, index)" :key="i" v-if="i<5">
              {{e.subName}}
              <img :src="`${baseUrl}images/tab-down.png`" alt="" v-show="item.activeTab.subId==e.subId">
            </div>
          </template>
          <div class="tab-item" v-if="item.data.length>=5" @click="goSubject">更多+</div>
        </div>
        <div class="serve-box mt20 flex-box">
          <template v-for="(e, i) in item.activeTab.serveList">
            <div class="serve-item" :key="i" @click="goServe(e)" v-if="i<7">
              <div class="serve-logo">
                <img :src="e.serveLogo" alt="">
              </div>
              <div class="serve-name ellipsis">{{e.serveName}}</div>
            </div>
          </template>
          <div class="serve-item" @click="goSubject" v-if="item.activeTab.serveList.length>6">
            <div class="serve-logo">
              <img :src="`${baseUrl}images/more.png`" alt="">
            </div>
            <div class="serve-name ellipsis">更多</div>
          </div>
        </div>
      </div>
    </div>
    <IframeView ref="IframeView"></IframeView>
    <queryTypeModal
            :data="dataModal"
            @close="onDialogClose"/>
  </div>
</template>

<script>
    import queryTypeModal from "@/components/common/queryTypeModal.vue";
    import IframeView from "@/components/public/IframeView.vue";
    import { bpmnStartProcess} from '@/api/bpmnApi/bpmn';
export default {
  name: "SUBJECT",
  components: {queryTypeModal, IframeView},
  props: ['moduleData'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
        dataModal:{
            show: false,
            data:{},
        },
        middlePage:JSON.parse(window.sessionStorage.getItem('setConfig')).middlePage
    };
  },
  computed: {},
  created() {
    this.moduleData.cardModules.forEach(item => {
      if(item.data.length){
        item.activeTab = item.data[0];
      }
    });
  },
  mounted() {},
  destroyed() {},
  methods: {
    tabClick(item, index){
        this.moduleData.cardModules[index].activeTab = item;
      this.$forceUpdate()
    },
    goServe(row){
        if(row.serveType == '0' && row.queryType == '2'){
            this.dataModal.show = true
            this.dataModal.data = row
        }
        if(row.serveType == '0' && row.queryType == '1'){
            this.$refs.IframeView.showView(row.queryPcUrl, row.taskInstId,row.serveName);
        }
        if(row.serveType == '1' ){
            if(!this.middlePage){
                this.HandleApply(row)
            }else {
                let routeData = this.$router.resolve({
                    path: `/ServeCenterDetail`,
                    query:{id:row.serveId}
                });
                window.open(routeData.href);
            }

        }
    },
      onDialogClose() {
          this.dataModal.show = false
      },
      HandleApply(item){
          let processDefId=item.processDefId;
          bpmnStartProcess({processDefId}).then(({data})=>{
              if(data.code==0){
                  window.sessionStorage.setItem("processInstId", data.data.processInstId);
                  this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
                  // window.open(data.data.url);
              }else{
                  this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');
              }

          }).catch(err=>{
              this.$message.error("服务异常" );
          })
      },
    moreServe(){
      
    },
    goSubject(){
      let routeData = this.$router.resolve({path:'/serveCenter'})
      window.open(routeData.href);
    }
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less">
.module-box {

}
.tab-item {
  max-width: 132px;
  text-align: center;
  font-size: 18px;
  line-height: 38px;
  position: relative;
  margin: 0 50px;
  cursor: pointer;
  img {
    position: absolute;
    bottom: -7px;
    left: 50%;
    margin-left: -45px;
  }
}
.serve-box {
  background-color: #F5F6F8;
  padding: 14px 132px 0;
  flex-wrap: wrap;
  .serve-item {
    width: 234px;
    margin: 14px 0;
    cursor: pointer;
    user-select: none;
    .serve-logo {
      text-align: center;
      img {
        height: 60px;
        width: 60px;
      }
    }
    .serve-name {
      text-align: center;
      font-size: 18px;
      line-height: 46px;
    }
  }
}
</style>
